import { IContact } from './contact.type'
import { INote } from './note.type'

export enum CallStatus {
  queued = 'Queued',
  ringing = 'Ringing',
  cancelled = 'Cancelled',
  'participant-leave' = 'Completed',
  busy = 'Busy',
  'no-answer' = 'No Answer',
  failed = 'Failed',
  initiated = 'Initiated',
  'participant-join' = 'In Progress',
  'participant-hold' = 'On Hold',
}

export type ITwilioStatus =
  | 'queued'
  | 'initiated'
  | 'ringing'
  | 'participant-join'
  | 'completed'

export type ICallStatus =
  | 'Queued'
  | 'Ringing'
  | 'In Progress'
  | 'Cancelled'
  | 'Completed'
  | 'Busy'
  | 'No Answer'
  | 'Failed'
  | 'Initiated'

export type ICallTag =
  | 'Feedback'
  | 'Inquiry'
  | 'Resolved'
  | 'Unresolved'
  | 'Follow-up required'
  | 'High priority'

export type ICallType = 'Incoming' | 'Outgoing' | 'Decline' | 'Missed'

export type ICallAiJobStatus = 'pending' | 'processing' | 'completed' | 'failed'

export interface ICallAiJob {
  status: ICallAiJobStatus | string
  retry_count: number
}

export interface ICalls {
  answered_at?: string | null
  answer_tracking_version?: number | null
  call_id: string
  call_sid: string
  communication_log_id: string
  call_status: ICallStatus
  caller_number: string
  receiver_number: string
  duration: number
  waiting_time: number
  handling_time: number
  start_date_time: string
  end_date_time: string | Date | null
  contact_id: string
  transcript_text: string
  recording_url: string | null
  call_type: ICallType
  sentiments: string
  summary: string
  notes: string
  tags: ICallTag[] | null
  contact: IContact | null
  call_notes: INote[]
  call_ai_job?: ICallAiJob | null
  handled_by_user_id?: string | null
  handled_by_user?: {
    user_id: string
    first_name?: string | null
    last_name?: string | null
    username?: string | null
  } | null
}

export interface ICallCount {
  totalCount: number
  totalPercent: number
  totalClassname: string
  answeredCount: number
  answeredPercent: number
  answeredClassname: string
  missedCount: number
  missedPercent: number
  missedClassname: string
  declineCount: number
  declinePercent: number
  declineClassname: string
  followupCount: number
  followupPercent: number
  followupClassname: string
}

export interface ICallMetricAttributes {
  title: string
  description: string
  value: number
  neutral?: number
  negative?: number
  percentage: number
  classname?: string
}

export type ICallMetrics = {
  total: ICallMetricAttributes
  answered: ICallMetricAttributes
  missed: ICallMetricAttributes
  decline: ICallMetricAttributes
  followup: ICallMetricAttributes
  handlingTime: ICallMetricAttributes
  waitTime: ICallMetricAttributes
  csat: ICallMetricAttributes
}

export interface ICallRecording {
  call_recording_settings_id?: string
  clinic_id: string
  inbound_calls: boolean
  outbound_calls: boolean
  internal_calls?: boolean
  auto_start: boolean
  play_tone: boolean
  pause_recording_on_hold: boolean
  retention_period: number
  retention_period_unit: string
  retention_never_delete?: boolean
  encryption: boolean
  updated_by?: string | null
  date_time_created_at?: string
  date_time_updated_at?: string
}

export enum ICallDirection {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
}
